import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import SelectInput from "./SelectInput";

const SeasonSelect = ({ flagParameter = null, onSeasonChange }) => {

    const [selected, setSelected] = React.useState(null);

    const seasons = useSelector(state => state.seasons.seasons);
    const seasonOptions = seasons.filter(season => {
        if (flagParameter === null) return true;
        return season[flagParameter];
    }).map(season => ({ id: season.id, label: season.acronym }));

    const onChange = (newValue) => {
        setSelected(newValue);
        onSeasonChange(seasons.find(season => season.id === newValue));
    }

    useEffect(() => {
        if (seasonOptions.length > 0) {
            setSelected(seasonOptions[0].id);
            onSeasonChange(seasons[0]);
        }
    }, []);

    return (
        <SelectInput
            id="season"
            label="Época"
            options={seasonOptions}
            selected={selected}
            onChange={onChange} />
    )
}

export default SeasonSelect;
